import { ReactNode } from "react";

import { useAuth } from "contexts/AuthProvider";
import LoadingSpinner from "./LoadingSpinner";

export const AuthChecker = ({ children }: { children: ReactNode }) => {
  const { accessToken } = useAuth();

  if (!accessToken) {
    return <LoadingSpinner />;
  } else {
    return children;
  }
};
